/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentitySettingsFormConfiguration
 */
export interface IdentitySettingsFormConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof IdentitySettingsFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof IdentitySettingsFormConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof IdentitySettingsFormConfiguration
     */
    readonly providers?: Array<GuidIdAndLabel> | null;
}

export function IdentitySettingsFormConfigurationFromJSON(json: any): IdentitySettingsFormConfiguration {
    return IdentitySettingsFormConfigurationFromJSONTyped(json, false);
}

export function IdentitySettingsFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function IdentitySettingsFormConfigurationToJSON(value?: IdentitySettingsFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


